import { createAction, props } from '@ngrx/store';

import { TrailerGroupsItem } from '../../app/portal/pages/trailers/trailers.types';

/**
 * Действие для загрузки списка групп прицепов.
 */
export const loadTrailerGroups = createAction('[Trailers] Load Trailer Groups');

/**
 * Действие для успешной загрузки списка групп прицепов.
 *
 * @property {TrailerGroupsItem[]} list - Список групп прицепов.
 */
export const loadTrailerGroupsSuccess = createAction(
  '[Trailers] Load Trailer Groups Success',
  props<{ list: TrailerGroupsItem[] }>(),
);

/**
 * Действие для обработки ошибки при загрузке списка групп прицепов.
 *
 * @property {string} error - Сообщение об ошибке.
 */
export const loadTrailerGroupsFailure = createAction(
  '[Trailers] Load Trailer Groups Failure',
  props<{ error: string }>(),
);

/**
 * Действие для добавления новой группы прицепов.
 *
 * @property {TrailerGroupsItem} trailerGroup - Новая группа прицепов.
 */
export const addTrailerGroup = createAction(
  '[Trailers] Add Trailer Group',
  props<{ trailerGroup: TrailerGroupsItem }>(),
);

/**
 * Действие для обновления данных группы прицепов.
 *
 * @property {string} id - Идентификатор группы прицепов.
 * @property {Partial<TrailerGroupsItem>} changes - Изменения в данных группы прицепов.
 */
export const updateTrailerGroup = createAction(
  '[Trailers] Update Trailer Group',
  props<{ id: number; changes: Partial<TrailerGroupsItem> }>(),
);

/**
 * Действие для удаления группы прицепов.
 *
 * @property {string} id - Идентификатор группы прицепов.
 */
export const deleteTrailerGroup = createAction(
  '[Trailers] Delete Trailer Group',
  props<{ id: number }>(),
);
